export default __webpack_public_path__ + "src/images/bg_loading_blue-ef2f74.png";